import { c as _c } from "react/compiler-runtime";
import { isDefined } from '@morpho-org/morpho-ts';
import { Skeleton } from '@morpho-org/ui-v6/server';
import { cn } from '@morpho-org/ui-v6/utils';
import NumberFlow from '@number-flow/react';
import { memo } from 'react';
interface SelectTokenPriceUsdProps {
  focused: boolean;
  disabled?: boolean;
  usdNumber?: number;
  footerExtra: React.ReactNode;
  amountPriceUsd: React.ReactNode;
  isLoading?: boolean;
  hasError?: boolean;
}
const SelectTokenPriceUsd = t0 => {
  const $ = _c(10);
  const {
    focused,
    disabled,
    usdNumber,
    footerExtra,
    amountPriceUsd,
    isLoading,
    hasError
  } = t0;
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Skeleton className="h-[18px] w-[40px]" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const t1 = hasError ? "text-destructive-foreground" : !focused || disabled ? "text-muted-foreground" : "text-secondary-foreground";
  let t2;
  if ($[1] !== t1) {
    t2 = cn("text-3xs h-[18px] truncate leading-none break-all", t1);
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== amountPriceUsd || $[4] !== footerExtra || $[5] !== usdNumber) {
    t3 = isDefined(usdNumber) ? <><span className="gap-2xs hidden flex-row items-center md:inline-flex"><NumberFlow value={usdNumber ?? 0} prefix="$" locales="en-US" format={{
          notation: "compact",
          compactDisplay: "short",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          trailingZeroDisplay: "stripIfInteger"
        }} />{footerExtra}</span><span className="gap-2xs inline-flex flex-row items-center md:hidden">{amountPriceUsd}{footerExtra}</span></> : <span className="gap-2xs flex flex-row items-center">{amountPriceUsd}{footerExtra}</span>;
    $[3] = amountPriceUsd;
    $[4] = footerExtra;
    $[5] = usdNumber;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <span className={t2}>{t3}</span>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default memo(SelectTokenPriceUsd);